import { addDays } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Modal, ButtonGroup, Button, Shelf } from '@chaser/components';
import useUpdateEffect from '../../../../hooks/useUpdateEffect';
import OrganisationService from '../../../../services/organisation-service';
import ChaserDatePicker from '../../../ChaserDatePicker';
import ChaserRadioButton from '../../../ChaserRadioButton/index';
import usePush from '../../../../hooks/usePush';
import { useCacheActions } from '../../../../hooks/useFetch';
import useShortCode from '../../../../hooks/useShortCode';

const ScheduleChasingModal = ({ open, close, pauseUntil = undefined }) => {
  const shortCode = useShortCode();
  const { execute, loading } = usePush(OrganisationService.pauseChasing);
  const [resumeDate, setResumeDate] = useState(() => pauseUntil || addDays(new Date(), 7));
  const { invalidateDomain } = useCacheActions();

  useUpdateEffect(
    didUpdate => {
      if (!didUpdate) return;
      setResumeDate(pauseUntil || addDays(new Date(), 7));
    },
    [pauseUntil],
  );

  return (
    <Modal
      open={open}
      toggle={close}
      title="Schedule a resume date"
      body={
        <Shelf>
          <ChaserRadioButton checked text="Resume Chaser on" />
          <ChaserDatePicker
            closeOnSave
            defaultValue={resumeDate}
            setDate={date => setResumeDate(date)}
            showActionButtons={false}
            showDeleteButton={false}
          />
        </Shelf>
      }
      footer={
        <ButtonGroup>
          <Button appearance="secondary" onClick={() => close(false)}>
            Cancel
          </Button>
          <Button
            loading={loading}
            onClick={async () => {
              await execute(shortCode, resumeDate);
              invalidateDomain('organisation');
              close(false);
            }}
          >
            Set Resume Date
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default ScheduleChasingModal;

ScheduleChasingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  pauseUntil: PropTypes.instanceOf(Date),
};
